export const firebaseConfig = {
    apiKey: 'AIzaSyAHBwYHhvQ_ZPtV4mWuH4TTZCysBV8UGNg',
    authDomain: 'olivier-rousseau-guyot.firebaseapp.com',
}